import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function ForbiddenPage() {
  useEffect(() => {
    document.title = '403 Adgang nægtet - Borgs Køreskole I/S'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Du har ikke adgang til denne side hos Borgs Køreskole I/S.'
      )
    }
  }, [])

  return (
    <div className="bg-slate-50 min-h-[70vh] flex items-center justify-center py-20 px-4">
      <div className="max-w-md w-full text-center bg-white p-8 sm:p-10 rounded-3xl border border-slate-200 shadow-xl space-y-6">
        <div className="w-20 h-20 rounded-3xl bg-amber-100 text-amber-700 mx-auto flex items-center justify-center text-3xl font-bold">
          <i className="fa-solid fa-lock" aria-hidden="true"></i>
        </div>

        <div>
          <span className="text-amber-600 font-extrabold text-sm uppercase tracking-wider block mb-1">
            Fejlkode 403
          </span>
          <h1 className="font-header text-3xl font-extrabold text-slate-900">
            Adgang Nægtet
          </h1>
          <p className="mt-2 text-slate-600 text-sm leading-relaxed">
            Du har ikke tilladelse til at tilgå denne ressource. Kontakt os venligst hvis du mener dette er en fejl.
          </p>
        </div>

        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm shadow-md transition-colors inline-flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-house" aria-hidden="true"></i>
            <span>Gå til Forsiden</span>
          </Link>

          <Link
            to="/kontakt"
            className="w-full sm:w-auto px-6 py-3 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-800 font-bold text-sm transition-colors"
          >
            Kontakt os
          </Link>
        </div>
      </div>
    </div>
  )
}
